export default __webpack_public_path__ + "static/media/Dickstar.15600a5c.PNG";